/**
 * MarketBrewer LLC - Constants
 *
 * Central source of truth for company and personal information.
 *
 * @example
 * import { JORGE, COMPANY, CONTACT } from '@/constants';
 */

// =============================================================================
// JORGE GIRALDEZ
// =============================================================================

export const JORGE = {
  FULL_NAME: "Jorge Giraldez",
  FIRST_NAME: "Jorge",
  LAST_NAME: "Giraldez",
  TITLE: "Digital Marketing Specialist & Website Developer",
  YEARS_EXPERIENCE: 10,

  BIO: {
    SHORT:
      "Digital Marketing Specialist with 10+ years of experience building digital marketing infrastructures that drive business growth.",
    FULL: "Jorge Giraldez helps Washington DC metro area businesses grow their online presence and increase revenue through strategic digital marketing and custom web development. With over a decade of proven results, he specializes in SEO optimization, marketing automation, and high-converting custom-built websites that drive measurable business growth.",
  },

  EXPERTISE: [
    "AWS Cloud Architecture",
    "React Development",
    "Technical SEO",
    "Local SEO",
    "Email Marketing",
    "Google Business Profile Optimization",
  ],

  SOCIAL: {
    LINKEDIN: "https://www.linkedin.com/in/jorge-giraldez-51172810b",
    INSTAGRAM: "https://www.instagram.com/marketbrewer/",
    FACEBOOK: "https://www.facebook.com/marketbrewer",
    KICK: "https://kick.com/marketbrewer",
    YOUTUBE: "https://www.youtube.com/@marketbrewer",
    TIKTOK: "https://www.tiktok.com/@marketbrewer",
  },
} as const;

// =============================================================================
// MARKETBREWER LLC
// =============================================================================

export const COMPANY = {
  NAME: "MarketBrewer LLC",
  SHORT_NAME: "MarketBrewer",
  URL: "https://marketbrewer.com",
  DOMAIN: "marketbrewer.com",

  LOCATION: {
    CITY: "Reston",
    STATE: "VA",
    COUNTRY: "US",
  },

  SERVICE_AREA: "DC Metro",
  TAGLINE: "Digital Marketing & Web Development",
} as const;

// =============================================================================
// CONTACT
// =============================================================================

export const CONTACT = {
  EMAIL: "inquiry@marketbrewer.com",

  PHONE: {
    // ONLINE public line (website, GBP, directories) — Google Voice. Jorge ruling 2026-09-23
    // (supersedes the 2026-07-08 ruling that put the Amazon Connect 202 line here; Connect is retired)
    GOOGLE_VOICE: "5714497422",
    GOOGLE_VOICE_FORMATTED: "(571) 449-7422",

    // Flyers + direct business only — NEVER on the website (Jorge ruling 2026-07-08)
    _PRIVATE_MAIN: "7034636323", // Jorge's personal cell
  },

  HOURS: {
    DAYS: "Monday - Friday",
    TIME: "9:00 AM - 5:00 PM EST",
  },
} as const;

// =============================================================================
// GOOGLE BUSINESS PROFILE
// =============================================================================

/**
 * The place ID is the only piece of Places API data Google permits storing
 * indefinitely. Everything else about the profile — rating, review count,
 * review text — is pulled fresh and transcribed by hand, never cached here.
 *
 * Verified against Places API (New) on 2026-07-31. CID 690215954401072633
 * matches the profile URL; both URLs below returned HTTP 200.
 */
export const GOOGLE = {
  PLACE_ID: "ChIJgawOis85tokR-RVi7MAjlAk",
  PROFILE_URL: "https://www.google.com/maps?cid=690215954401072633",
  REVIEW_URL:
    "https://search.google.com/local/writereview?placeid=ChIJgawOis85tokR-RVi7MAjlAk",
} as const;

// =============================================================================
// SERVICES
// =============================================================================

export const SERVICES = [
  "Website Development",
  "Technical SEO",
  "Local SEO",
  "Google Business Profile Management",
  "Email Marketing",
  "Social Media Management",
  "Marketing Automation",
  "E-Commerce Development",
] as const;

// =============================================================================
// DEFAULT EXPORT
// =============================================================================

export default {
  JORGE,
  COMPANY,
  CONTACT,
  GOOGLE,
  SERVICES,
} as const;
